import { css } from "styled-components"

export const tabsStyle = css`
    text-transform: none;
    font-size: 20px;  

    @media (max-width: 435px) {
        font-size: 14px;      
    }

    @media (max-width: 320px) {
        min-width: auto;
        padding-left: 5px;
        padding-right: 5px;      
    }    
`
